import React from "react";
import { useFieldArray, useForm } from "react-hook-form";
import IcClose from "../../assets/icons/IcClose";
import {
  useGetProfileDdetailQuery,
  useUpdateUserTradeRefernceMutation,
} from "../../store/api/profileApi";
import { toast } from "sonner";
import InlineLoaderComponent from "../../components/common/InlineLoaderComponent";

const EditTradeReference = () => {
  const {
    data: profileData,
    isLoading: profileDataLoading,
    isFetching: profileDataFetching,
  } = useGetProfileDdetailQuery();
  const {
    register,
    handleSubmit,
    getValues,
    watch,
    clearErrors,
    control,
    setError,
    formState: { errors },
  } = useForm({
    mode: "onTouched", // or "onChange" or "all"
    reValidateMode: "onChange",
    defaultValues: {
      trade_reference: profileData?.trade_reference || [{}, {}, {}],
    },
  });
  const { fields, append, remove } = useFieldArray({
    control,
    name: "trade_reference",
  });
  const [updateTradeReference, { isLoading: updateTradeReferenceLoading }] =
    useUpdateUserTradeRefernceMutation();
  const onSubmit = async (formData) => {
    let data = formData;
    if (data.trade_reference.length < 3) {
      setError("trade_reference", {
        message: "Please add at least 3 trade references",
      });
      return;
    }
    let payload = {
      tradeReference: data.trade_reference.map((item) => ({
        companyName: item.company_name,
        personName: item.person_name,
        personEmail: item.person_email,
        personContactNumber: item.person_contact_number,
      })),
    };
    updateTradeReference(payload)
      .unwrap()
      .then(() => {
        toast.success("Trade reference updated successfully");
      });
  };
  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="d-flex justify-content-end my-3">
          <button
            type="button"
            onClick={() => {
              if (getValues("trade_reference").length === 2) {
                clearErrors("trade_reference");
              }
              append({
                company_name: "",
                person_name: "",
                person_email: "",
                person_contact_number: "",
              });
            }}
            className="submit-button"
          >
            Add Reference
          </button>
        </div>{" "}
        {fields.map((item, index) => (
          <div
            key={item.id}
            className="d-flex gap-2 align-items-center field-array-item"
          >
            <div className="form-group">
              <label>Company Name</label>
              <input
                {...register(`trade_reference.${index}.company_name`, {
                  required: "Company Name is required",
                })}
                className="form-input"
              />
              {errors.trade_reference?.[index]?.company_name && (
                <span className="error-message">
                  {errors.trade_reference[index].company_name.message}
                </span>
              )}
            </div>

            <div className="form-group">
              <label>Person Name</label>
              <input
                {...register(`trade_reference.${index}.person_name`, {
                  required: "Person Name is required",
                })}
                className="form-input"
              />
              {errors.trade_reference?.[index]?.person_name && (
                <span className="error-message">
                  {errors.trade_reference[index].person_name.message}
                </span>
              )}
            </div>

            <div className="form-group">
              <label>Person Email</label>
              <input
                {...register(`trade_reference.${index}.person_email`, {
                  required: "Person Email is required",
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: "Invalid email address",
                  },
                })}
                className="form-input"
              />
              {errors.trade_reference?.[index]?.person_email && (
                <span className="error-message">
                  {errors.trade_reference[index].person_email.message}
                </span>
              )}
            </div>

            <div className="form-group">
              <label>Contact Number</label>
              <input
                {...register(`trade_reference.${index}.person_contact_number`, {
                  required: "Contact Number is required",
                  pattern: {
                    value:
                      /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/,
                    message: "Invalid contact number",
                  },
                })}
                className="form-input"
                type="tel"
              />
              {errors.trade_reference?.[index]?.person_contact_number && (
                <span className="error-message">
                  {errors.trade_reference[index].person_contact_number.message}
                </span>
              )}
            </div>

            <div onClick={() => remove(index)} className="close-icon">
              <IcClose />
            </div>
          </div>
        ))}
        {errors.trade_reference && (
          <span className="error-message mb-3">
            {errors.trade_reference.message}
          </span>
        )}
        <div className={`d-flex justify-content-end `}>
          <button type="submit" className="submit-button">
            Submit
            {updateTradeReferenceLoading && <InlineLoaderComponent />}
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditTradeReference;
